import { render, staticRenderFns } from "./SpaceControllerView.vue?vue&type=template&id=1d75e153&scoped=true"
import script from "./SpaceControllerView.vue?vue&type=script&lang=js"
export * from "./SpaceControllerView.vue?vue&type=script&lang=js"
import style0 from "./SpaceControllerView.vue?vue&type=style&index=0&id=1d75e153&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d75e153",
  null
  
)

export default component.exports